export const lastPageLocalStorageKey = 'last-page'
